export enum InspectiondutyWizardNavigationPaths {
    DATA = 'data',
    OTHEREQUIPMENTS = 'otherequipments',

    NEXT = 'next',
    PREVIOUS = 'previous',
    START = 'start',
    EXIT = 'exit',
  }
